import $ from 'jquery';

export const breakpoint = () => {
  return window.getComputedStyle(document.querySelector('body'), '::before')
      .getPropertyValue('content')
      .replace(/\"/g, '');
};


